<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-upload2`]" width="1em" height="1em" v-bind="$attrs"><path d="M3.58398 10.48C3.58398 7.67972 3.58398 6.27959 4.12895 5.21003C4.60832 4.26922 5.37322 3.50431 6.31403 3.02495C7.38359 2.47998 8.78372 2.47998 11.584 2.47998H12.7303C13.8128 2.47998 14.3541 2.47998 14.8666 2.58855C15.4557 2.71337 16.0174 2.94358 16.5247 3.26811C16.966 3.5504 17.3516 3.93024 18.1227 4.68992C18.9099 5.4654 19.3035 5.85314 19.5962 6.2998C19.9327 6.81326 20.1717 7.38429 20.3014 7.98433C20.4142 8.50631 20.4142 9.05881 20.4142 10.1638V13.1802C20.4142 15.9805 20.4142 17.3806 19.8692 18.4502C19.3899 19.391 18.6249 20.1559 17.6841 20.6352C16.6146 21.1802 15.2144 21.1802 12.4142 21.1802H11.584C8.78372 21.1802 7.38359 21.1802 6.31403 20.6352C5.37322 20.1559 4.60832 19.391 4.12895 18.4502C3.58398 17.3806 3.58398 15.9805 3.58398 13.1802V10.48Z" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><path d="M11.8984 7.3139L11.8984 12.924M14.7619 10.1773L11.8984 7.3139 9.03502 10.1773M9.19336 16.1965H14.8034" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorUpload2',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
